import CMSFields from './cms_fields.ts'
import {LocalLanguage} from "@/types_and_interfaces/types";


class CMS {

    static docs = {
        "general_info":"general_info",
        "credit_line":"credit-line",
        "offices":"offices",
        "conf_ident_data":"confirm-identity",
        "banks":"banks",
        "init_scripts": "init_scripts",
        "copyright_inf": "copyright_inf",
        "app_doc": "app_doc",
        "doc_app_links": "doc_app_links",
    }
    
    static module = {
        "app_docs": "app_docs"
    }
    
    static general_info:any = {}
    static copyright_inf:any = {}
    // static cr_line_data:any = {}
    static ["credit-line"]:any = {}
    static pep:any = {}
    static offices:any = {}
    static ["confirm-identity"]:any = {}
    static banks:any = {}
    static stores:any = {}
    static online_payment:any = {}
    static e_payments:any = {}
    static app_links:any = {}
    static app_promo_list:any = {}
    static loan_info_content:any = {}
    static sign_contract_agreements:any = {}
    
    static getCabinetOffers = () => {
        return this.getDocRepeaters(this.app_promo_list.items_list, "article")?.filter((x:any) => x.cabinet_visible)
    }
    
    static getDocRepeaters = (json:any, object_type?:string) => {
        
        let res:any = []
        
        if (typeof json === "object" ) {
            Object.entries(json).forEach((x) => {
                if(Array.isArray(x[1])) {
                    let arr = x[1]
                    
                    arr.forEach((obj) => {
                        let k1 = Object.keys(obj)[0]
                        let types = obj[k1].value.d_value.types
                        let custom_type
                        let api_id = obj[k1].value.d_value.api_id
                        
                        if(Array.isArray(types) && types.length){
                            
                            if(object_type) {
                                custom_type = types.find((y) => y.type === object_type)
                            } else {
                                custom_type = types[0]
                            }
                            custom_type = this.getAllFields(custom_type)
                            custom_type.api_id = api_id
                            res.push(custom_type)
                        }
                    })
                }
            })
        }
        
        return res
    }

    static getAllFields = (json:any):any => {
        let result:any = {}
        
        if(typeof json === "object") {
            let keys = Object.keys(json)
            
            keys.forEach((k:string) => {
                let res = CMSFields.detectFieldType(json[k])
                if(res) result[k] = res
            })
            
            let result_keys = Object.keys(result)
            
            result_keys.forEach((k) => {
                if(Array.isArray(result[k])){
                    
                    result[k].map((item:any, i:number) => {
                        if(typeof item === "object") {
                            let item_keys = Object.keys(item)
                            
                            item_keys.forEach((k1) => {
                                if(typeof item[k1] == "object") {
                                    let item_keys1 = Object.keys(item[k1])
                                    
                                    item_keys1.forEach((k2) => {
                                        
                                        if (Array.isArray(result[k][i][k1][k2])) {
                                            for (let j = 0; j < result[k][i][k1][k2].length; j++) {
                                                const currentItem = result[k][i][k1][k2][j];
                                                if (typeof currentItem === "object" && Object.keys(currentItem).length > 0) {
                                                    const res3 = this.getAllFields(currentItem);
                                                    if (typeof res3 === "object" && Object.keys(res3).length > 0) {
                                                        result[k][i][k1][k2][j] = res3;
                                                    }
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
        
        return result
    }
    
    static langAwareFilter = (json:any, lang: LocalLanguage):any => {
        let res:any = {}

        const keys = Object.keys(json)

        keys.map((k) => {
            if(k[2] === "_" && (k.slice(0, 2) === "ro" || k.slice(0, 2) === "ru") ) {
                res[k.slice(3)] = json[lang + "_" + k.slice(3)]
            } else {
                res[k] = json[k]
            }
        })

        return res
    }

    static getLangAwareArr = (arr:Array<any>, ln:LocalLanguage) => {

        let res:Array<any> = []
        if(Array.isArray(arr) && arr.length) {
            arr.map((json) => {
                let ob = CMS.langAwareFilter(json, ln)
                res.push(ob)
            })
        }

        return res
    }

    static getFilePath = (path: string) => {
        return import.meta.env.VITE_CMS_API + path
    }
    
}

export default CMS